/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespPriceTiles_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespPriceTiles_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeOnApprovalPromoTile_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
